import script from "./createKHM.vue?vue&type=script&setup=true&lang=js"
export * from "./createKHM.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__